const s = (C) => /\d/.test(C), w = ({
  phoneBeforeInput: C,
  phoneAfterInput: n,
  phoneAfterFormatted: l,
  cursorPositionAfterInput: x,
  leftOffset: k = 0,
  deletion: u
}) => {
  if (x < k)
    return k;
  if (!C)
    return l.length;
  const D = u === "backward";
  if (x === 0 && n.length > 0 && l.length > 0) {
    if (D) return 0;
    for (let i = 0; i < l.length; i += 1)
      if (s(l[i]))
        return i;
    return l.length;
  }
  if (n.length < C.length && n.length === 1)
    return l.length;
  let b = null;
  for (let i = x - 1; i >= 0; i -= 1)
    if (s(n[i])) {
      b = i;
      break;
    }
  if (b === null)
    return x !== 0 ? x : l.length;
  let e = 0;
  for (let i = 0; i < b; i += 1)
    s(n[i]) && (e += 1);
  D && (e -= 1);
  let g = 0, r = 0;
  for (let i = 0; i < l.length && (g += 1, s(l[i]) && (r += 1), r !== e + 1); i += 1)
    ;
  for (; !s(l[g]) && g < l.length; )
    g += 1;
  return D && (g += 1), g;
};
export {
  w as getCursorPosition
};
